
export default {

  methods: {
    sampleToSlug: function (key) {
      return key.replace(/_/g, '-').toLowerCase()
    },
    slugToSample: function (slug) {
      return slug.replace(/-/g, '_').toUpperCase()
    },
    sampleToString: function (key) {
      return this.uFirst(key.replace(/_/g, ' '))
    },
    sampleToDisplay: function (key) {
      let explode = key.split('_')
      const stringLength = explode.length
      if (stringLength === 1) {
        return this.sampleToString(key)
      }
      var rtn = ''
      var i = 0
      if (explode[0].length === 1) {
        i = 1
      }

      while (i < stringLength) {
        if (explode[i] !== '') {
          if (rtn.length >= 1) { rtn += ' ' }
          rtn += this.uFirst(explode[i])
        }
        i++
      }
      return rtn
    },
    uFirst: function (string) {
      const lower = string.toLowerCase()
      return lower.charAt(0).toUpperCase() + lower.slice(1)
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/@microbadevs/report/src/mixins/apiStringMapping.js
// module id = XHO7
// module chunks = 0